<template>
  <div class="about">
    <div class="mask mask--page-title">
      <h1 class="page-title js-page-title">à propos</h1>
    </div>
    <cms-content class="content js-content" v-html="content"></cms-content>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CmsContent from '@/components/CMSContent';

export default {
  name: 'about-view',
  components: {
    CmsContent
  },

  computed: mapState({
    content: state => state.content.about
  }),

  methods: {
    enter(done) {
      const tl = new TimelineMax({
        onComplete: done
      });

      const $pageTitle = this.$el.querySelector('.js-page-title');
      const $content = this.$el.querySelector('.js-content');

      tl.set($pageTitle, {
        y: '100%'
      });

      tl.set($content, {
        autoAlpha: 0,
        y: 70
      });

      tl.to($pageTitle, 0.6, {
        y: '0%',
        ease: Quart.easeOut,
        force3D: true
      });

      tl.to(
        $content,
        0.6,
        {
          autoAlpha: 1,
          y: 0,
          ease: Quart.easeOut,
          force3D: true
        },
        0.1
      );
    },

    leave(done) {
      const tl = new TimelineMax({
        onComplete: done
      });

      const $pageTitle = this.$el.querySelector('.js-page-title');
      const $content = this.$el.querySelector('.js-content');

      tl.to($pageTitle, 0.4, {
        y: '-104%',
        ease: Quart.easeOut,
        force3D: true
      });

      tl.to(
        $content,
        0.4,
        {
          autoAlpha: 0,
          y: -70,
          ease: Quart.easeOut,
          force3D: true
        },
        0.1
      );
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.about {
  padding-bottom: 94px;
}

.content {
  max-width: 51.25em;
  margin: 0;
  font-size: 1.25em;
}
</style>


// WEBPACK FOOTER //
// AboutView.vue?432d67ce